import { Either } from "../../core/types/Either";
import { Quote } from "../entity/Quote";

export abstract class QuoteRepository {
  abstract getQuotes(): Promise<Either<Error, Array<Quote>>>;
}
